import { createApp } from "vue";
import html from "./savetheDetail.html";
import { may, toDate, flatPickrConfig, traduit } from "../composant/b2bLangue";

import { bootbox } from "../../B2bTools"
import Store from "../../Store";


const imagPardefaut = "0000000/0000000_0000_1_L.png"

function triSection(linelists) {
	const regroupements = {};
	for (const linelist of linelists) {
		const regroupement = linelist.regroupement || "test";

		if (!regroupements[regroupement]) {
			regroupements[regroupement] = { k: regroupement, rows: [] };
		}
		regroupements[regroupement].rows.push(linelist);
	}
	const array = [];
	for (const key in regroupements) {
		regroupements[key].rows.sort(function (a, b) { return (a.sortkey || "").localeCompare(b.sortkey) })
		array.push(regroupements[key]);
	}
	//
	array.sort(function (a, b) { return a.k.localeCompare(b.k) });
	return array;
}


const js = ({
	url: function (echangeur) {
		// echangeur.addAction('b2b.env.get', echangeur.hash, '', 'data');
		echangeur.addAction('b2b.SaveThe.get', echangeur.hash, '', 'data');
		echangeur.addAction("b2b.SaveThe.list", echangeur.hash, "", "list");

	},
	onLoad: function (echangeur) {
		const THIS = this;
		const env = echangeur.hash.env;
		const id = echangeur.hash._id

		const marketK = echangeur.hash.marketK;
		const orderepartement =  echangeur.hash.orderepartement;

		let profil = Store.get("CTX").session.profilName;
		let profils = ["dmk-admin", "dmk-bda", "dmk-bd", "dmk-conception"]
		let editable = (profils.indexOf(profil) > -1);



 
			let title = echangeur.data.v;
			let o =  echangeur.data.k;
			let ord  = echangeur.list.ords[o];
			//
			if(ord && ord.orderdep) title = ord.orderdep.v;  
	   

		const app = createApp({
			data() {
				// const datas = triSection(env.linelists.filter(u => !u.parent));
				return {
					by: echangeur.data.by,
					datas: echangeur.data.rows,
					title: title,
					k: echangeur.data.k,
					editable: editable,
					erreurs: ""
				}
			},
			computed: {
			},

			methods: {
				url(product) {
					return (product.img) ? `download/product/${product.img.replace("*", "L")}` : `download/product/${imagPardefaut}`;
				},
				toDate: function (date) {
					return toDate(date);
				},
				back() {
					THIS.fin();
				},
				toVpop(value) {
					return (value || "no value").split("|").pop();
				},
				toVshift(value) {
					return (value || "no value").split("|").shift();
				},
				async remove() {
					let th = this;
					bootbox.confirm({
						title: 'Save The Reset',
						message: `Are you sure to reset <b> ${orderepartement} ${env} </b> ?` 
					},
						async function () {
							const retour = await THIS.rest('b2b.SaveThe.remove', { orderepartement: orderepartement , marketK : marketK, env:env});
							if (retour.done) {
								THIS.fin();
							} else {
								th.erreurs = "errors"
							}
						})



				}
			},

			mounted() {
				// this.title = this.toVpop(this.datas.map(u => u.k).find(u => this.toVshift(u) === this.toVshift(id)))
			}

		});

		this.vm = app.mount(THIS.c$('._vueChargement')[0]);
	},
});

export default {
	savetheDetail: { js: js, html: html }
};
